/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClinicStatisticsNew,
  ErrorResponse,
  FinancialStatistics,
  NamedStringResource,
  PaidImmunizationDetail,
  SesEmailStatsEntry,
} from '../models';
import {
    ClinicStatisticsNewFromJSON,
    ClinicStatisticsNewToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FinancialStatisticsFromJSON,
    FinancialStatisticsToJSON,
    NamedStringResourceFromJSON,
    NamedStringResourceToJSON,
    PaidImmunizationDetailFromJSON,
    PaidImmunizationDetailToJSON,
    SesEmailStatsEntryFromJSON,
    SesEmailStatsEntryToJSON,
} from '../models';

export interface GetPaidImmunizationsRequest {
    from: number;
    to?: number;
}

export interface GetSesEmailStatsRequest {
    from: number;
    to?: number;
}

/**
 * 
 */
export class StatsApi extends runtime.BaseAPI {

    /**
     * Gets the external dashboards (Roles: admin)
     */
    async getExternalDashboardRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NamedStringResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/external-dashboards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NamedStringResourceFromJSON));
    }

    /**
        Request Config Getter
     */
    getExternalDashboardRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/external-dashboards`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the external dashboards (Roles: admin)
     */
    async getExternalDashboard(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NamedStringResource>> {
        const response = await this.getExternalDashboardRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the financial stats (Roles: admin)
     */
    async getFinancialStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialStatistics>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/financial`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialStatisticsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getFinancialStatsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/financial`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the financial stats (Roles: admin)
     */
    async getFinancialStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialStatistics> {
        const response = await this.getFinancialStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets data for all clinics to be used in statistics. (Roles: admin, physician)
     */
    async getNewClinicStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClinicStatisticsNew>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/clinics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClinicStatisticsNewFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getNewClinicStatsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/clinics`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets data for all clinics to be used in statistics. (Roles: admin, physician)
     */
    async getNewClinicStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClinicStatisticsNew> {
        const response = await this.getNewClinicStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all paid immunizations system-wide with invoice details (Roles: admin)
     */
    async getPaidImmunizationsRaw(requestParameters: GetPaidImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaidImmunizationDetail>>> {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPaidImmunizations.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/paid-immunizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaidImmunizationDetailFromJSON));
    }

    /**
        Request Config Getter
     */
    getPaidImmunizationsRequestOptionsRaw(requestParameters: GetPaidImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPaidImmunizations.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/paid-immunizations`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all paid immunizations system-wide with invoice details (Roles: admin)
     */
    async getPaidImmunizations(requestParameters: GetPaidImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaidImmunizationDetail>> {
        const response = await this.getPaidImmunizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets SES email statistics for a date range (Roles: admin, manager)
     */
    async getSesEmailStatsRaw(requestParameters: GetSesEmailStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SesEmailStatsEntry>>> {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getSesEmailStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/stats/ses-email`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SesEmailStatsEntryFromJSON));
    }

    /**
        Request Config Getter
     */
    getSesEmailStatsRequestOptionsRaw(requestParameters: GetSesEmailStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getSesEmailStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/stats/ses-email`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets SES email statistics for a date range (Roles: admin, manager)
     */
    async getSesEmailStats(requestParameters: GetSesEmailStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SesEmailStatsEntry>> {
        const response = await this.getSesEmailStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
